import type { DragEvent } from 'react';

/**
 * Native HTML drag and drop of a matrix onto a folder of the column (issue
 * #19, hypothèse 9). The payload is the matrix id under a custom type, so a
 * stray file or link dragged over the column is never taken for a matrix.
 * « Déplacer vers » stays the keyboard path.
 */
export const MATRIX_DRAG_TYPE = 'application/x-mss-matrix';

/** Spread on a card or a row to make it draggable. */
export function matrixDragProps(matrixId: string) {
  return {
    draggable: true as const,
    onDragStart: (event: DragEvent<HTMLElement>) => {
      event.dataTransfer.setData(MATRIX_DRAG_TYPE, matrixId);
      event.dataTransfer.effectAllowed = 'move';
    },
  };
}

/** Whether a drag in progress carries a matrix (readable during `dragover`, when the data is not). */
export function isMatrixDrag(event: DragEvent<HTMLElement>): boolean {
  return Array.from(event.dataTransfer.types).includes(MATRIX_DRAG_TYPE);
}

/** The id of the dropped matrix, or null when the drop carries none. */
export function readDroppedMatrixId(event: DragEvent<HTMLElement>): string | null {
  const id = event.dataTransfer.getData(MATRIX_DRAG_TYPE);
  return id === '' ? null : id;
}
